/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Denied_DescriptionInputs */

const en_agent_authorization_denied_description = /** @type {(inputs: Agent_Authorization_Denied_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No project token was issued. The Agent cannot manage this project through Seek AI.`)
};

const zh_agent_authorization_denied_description = /** @type {(inputs: Agent_Authorization_Denied_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统没有签发项目 token，Agent 无法通过 Seek AI 管理此项目。`)
};

/**
* | output |
* | --- |
* | "No project token was issued. The Agent cannot manage this project through Seek AI." |
*
* @param {Agent_Authorization_Denied_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_denied_description = /** @type {((inputs?: Agent_Authorization_Denied_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Denied_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_denied_description(inputs)
	return zh_agent_authorization_denied_description(inputs)
});
export { agent_authorization_denied_description as "agent.authorization.denied_description" }